import React from "react";
import { CreateOrEditUserRolePage } from "~/areas/configuration/components/Roles/CreateOrEditUserRolePage";
interface UserRolePageProps {
    roleId: string;
}
export function UserRolePage({ roleId }: UserRolePageProps) {
    return <CreateOrEditUserRolePage roleId={roleId}/>;
}
